/* eslint-disable import/no-named-as-default, import/no-named-as-default-member */
import SUPPORT_TYPE from '@integrations/pint-appstore-commons/src/enums/SUPPORT_TYPE.json';
import ACTION_TYPE from './store/ACTION_TYPE';

export default {
    filters: {
        age: 'add-ons & integrations',
        new: 'new',
        custom: 'custom',
        type: 'type',
        status: 'status',
        egnyte_ui: 'Egnyte add-ons',
        web: 'external integrations',
        egnyte_apps: 'Egnyte Apps',
        admin_notEnabled: 'not enabled',
        admin_allowedToUsers: 'Allowed for users',
        admin_addedToUsers: 'Added for all users',
        admin_addedForGroups: 'Added for groups',
        user_added: 'added',
        user_addAvailable: 'available to add',
        user_notEnabled: 'not enabled',
        categories: 'categories',
        analytics: 'analytics',
        casb: 'CASB',
        chat: 'chat',
        coEditing: 'co-editing',
        collaboration: 'collaboration',
        crm: 'CRM',
        email: 'e-mail',
        editing: 'editing',
        esignature: 'esignature',
        forms: 'forms',
        migration: 'migration',
        mobile: 'mobile',
        projectManagement: 'project management',
        sales: 'sales',
        security: 'security',
        sso: 'SSO',
        workflow: 'workflow',
        industries: 'industries',
        construction: 'construction',
        financialServices: 'financial services',
        healthcareAndLifeSciences: 'healthcare & life sciences',
        legal: 'legal',
        mediaAndAdvertising: 'media & advertising',
        platform: 'works with',
        connect: 'Egnyte Collaborate',
        protect: 'Egnyte Secure & Govern',
        unifiedPlatform: {
            protect: 'Egnyte Secure & Govern',
            connect: 'Egnyte Collaborate',
        },
        'certified-desktop-apps': 'Certified Desktop Apps',
    },
    user: {
        adminMode: 'Admin Mode',
        lostSession: 'Your session expired. Reload the page to start over.',
        sessionExpired: 'Session expired!',
    },
    filtersSuggestionSection: {
        promoText: "Can't find an integration?",
        linkText: 'Request it',
    },
    navbar: {
        all: 'All Apps & Integrations',
        appCenter: 'App Control Center',
        unifiedPlatform: {
            all: 'All',
            protect: 'Secure & Govern',
            connect: 'Collaborate',
        },
    },
    appDetails: {
        linkToPage: 'Get link to this page',
    },
    AppDomainSettings: {
        mainInformation: 'This integration requires additional configuration to work properly.',
        userManualInformation: {
            part_1: 'View the ',
            part_2: ' to follow the installation guide.',
            linkName: 'User Manual',
        },
        configuration: 'Configuration',
        required: 'required',
        subInformationConfigure: 'From here you can start integration’s setup.',
        subInformationEdit: 'Setup completed',
        coEditDefaultTooltip:
            'To provide the best experience for your users, consider setting a default co-editing app.',
        buttonConfigure: 'Start configuration',
        buttonEdit: 'Edit configuration',
    },
    filtersTooltips: {
        egnyte_ui: 'Egnyte Add-Ons enable new actions within the Egnyte web interface',
        web: 'External Integrations are enabled or accessed from outside the Egnyte web interface',
    },
    notifications: {
        [ACTION_TYPE.APP_SETTINGS_CHANGED_FULFILLED]: 'Application settings changed',
        [ACTION_TYPE.SUBMIT_FEEDBACK_FULFILLED]: 'Your feedback has been submitted',
        [ACTION_TYPE.COPY_PERMALINK]: 'Link was copied',
        [ACTION_TYPE.ADD_SIDELOADED_APP_FULFILLED]: 'App Manifest successfully added.',
        [ACTION_TYPE.REUPLOAD_SIDELOADED_APP_FULFILLED]: 'App Manifest successfully changed.',
        [ACTION_TYPE.REMOVE_SIDELOADED_APP_FULFILLED]: 'App successfully deleted.',
        [ACTION_TYPE.SUGGEST_SETTING_DEFAULT_APP]:
            'To provide the best experience for your users, consider setting a default co-editing app.',
        [ACTION_TYPE.REMOVE_SIDELOADED_APP_REJECTED]: '',
        [ACTION_TYPE.REQUEST_APPS_REJECTED]: '',
        [ACTION_TYPE.APP_SETTINGS_CHANGED_REJECTED]: '',
        [ACTION_TYPE.REQUEST_APP_REJECTED]: '',
        [ACTION_TYPE.REQUEST_SEARCH_GROUPS_REJECTED]: '',
        [ACTION_TYPE.SUGGEST_APP_REJECTED]: '',
        [ACTION_TYPE.HIDE_NOTIFICATION]: '',
        [ACTION_TYPE.DESTROY_NOTIFICATION]: '',
        [ACTION_TYPE.SUBMIT_FEEDBACK_REJECTED]: '',
        [ACTION_TYPE.UPDATE_CUSTOM_DATA_FULFILLED]: 'Application settings changed',
    },
    supportTags: {
        tag: {
            [SUPPORT_TYPE.USER_SELF_SUPPORT]: 'User Self Support',
            [SUPPORT_TYPE.PARTNER_SUPPORTED]: 'Partner Supported',
            [SUPPORT_TYPE.EGNYTE_SUPPORTED]: 'Egnyte Supported',
            [SUPPORT_TYPE.ADMIN_SUPPORTED]: 'Custom Application',
        },
        tooltip: {
            [SUPPORT_TYPE.USER_SELF_SUPPORT]:
                'Egnyte and the listed application are expected to be able to work together based on industry standard or protocol ' +
                'however, Egnyte does not offer support for this application.',
            [SUPPORT_TYPE.PARTNER_SUPPORTED]:
                'This integration is built and supported by the third party named in the application listing.',
            [SUPPORT_TYPE.EGNYTE_SUPPORTED]: 'This app is built and supported by Egnyte.',
        },
    },
    disableAppExplanations: {
        askToBecomePower: "Ask your administrator to change you to a Power User if you'd like to use this app",
        askAdminToEnable: 'Your administrator can enable this feature',
        askAdminToUpgrade: 'Ask your Administrator to upgrade your plan to enable this app',
        upgradeAsAdmin: 'Upgrade your plan to enable this app',
    },
    controlCenter: {
        title: 'App Control Center',
        header: 'Apps for editing documents',
        description: 'List of apps that support real-time co-editing documents with Egnyte products.',
        prioritizationCaption: 'Application prioritization',
        prioritizationExplanation:
            'Drag and Drop the list of applications below to change the priority for One-Click Co-editing. This will default Users to the highest available Co-editing tool according to the defined priority list.',
        prioritizationToggleTooltip:
            'In order to enable prioritization you need to have at least one application added',
        settings: 'Settings',
        panelHeaderName: 'app name',
        panelHeaderStatus: 'status',
        coeditPolicy: {
            title: 'Co-editing app defaults for the Egnyte Desktop app',
            info: 'These defaults will be applied to all the users when they double click on a file. End users must have at least Egnyte Desktop App for Windows v3.14.8 or Egnyte Desktop for Mac Core v0.7 or newer.',
            allowOverride: 'Allow users to override these defaults',
            policyOptions: {
                ask: 'Ask',
                neverCoedit: 'Never co-edit',
                alwaysCoedit: 'Always co-edit',
            },
        },
    },
};
